import Axios from 'axios';
import { stringify } from 'qs';
import { zhongbaoResponseHandler, zhongbaoErrorHandler } from 'common/service/utils/zhongbaoHandler';

export const ZhongbaoAxiosInstance = Axios.create({
  baseURL: '',
  timeout: 60000,
  paramsSerializer: function (params) {
    return stringify(params);
  },
});
ZhongbaoAxiosInstance.interceptors.response.use(zhongbaoResponseHandler, zhongbaoErrorHandler);
ZhongbaoAxiosInstance.interceptors.request.use(async (config: any) => {
  config.headers.originType = 'o';
  return config;
});
